export class ProfileModel {
  public id: number;
  public firstName: string;
  public lastName: string;
  public fullName: string;
  public email: string;
  public mobileNumber: string;
  public gender: number | null;
  public linkedin: string;
  public cooperation_type: number;
  public lastEducationDegree: number;
  public educationField: string;
  public charities: any[];
  public defaultCharityId: number | null;
  public positionsTitle: string;
  public hasApprovalRequired: boolean;
  public hasApprovalForRegistering: boolean;
  public avatar_id?: string;

  get charityTitle(): string {
    if (this.defaultCharityId && this.charities && this.charities.length > 0) {
      const defaultCharity = this.charities.find(
        (c) => c.id === this.defaultCharityId,
      );
      if (defaultCharity) {
        return defaultCharity.title;
      }
    }
    // Fallback to first charity
    if (this.charities && this.charities.length > 0) {
      return this.charities[0].title;
    }
    return '';
  }

  get defaultCharity(): any {
    if (this.defaultCharityId && this.charities && this.charities.length > 0) {
      return this.charities.find((c) => c.id === this.defaultCharityId);
    }
    return this.charities && this.charities.length > 0
      ? this.charities[0]
      : null;
  }

  get defaultPositions(): any[] {
    const charity = this.defaultCharity;
    return charity
      ? charity.positions.map((p: { title: string }) => p.title).join(' - ') ||
          []
      : [];
  }

  get defaultCooperationType(): string | null {
    const charity = this.defaultCharity;
    const cooperationType = charity ? charity.cooperationType : null;
    return cooperationType === 1 ? 'موظف' : 'داوطلب';
  }

  get profileAvatar(): string | null {
    if (this.avatar_id) {
      // Handle both URL and binary content
      if (
        typeof this.avatar_id === 'string' &&
        this.avatar_id.startsWith('http')
      ) {
        return this.avatar_id;
      } else if (
        typeof this.avatar_id === 'string' &&
        this.avatar_id.length > 0
      ) {
        return this.avatar_id;
      }
    }
    return null;
  }

  constructor(
    id: number,
    firstName: string,
    lastName: string,
    fullName: string,
    email: string,
    mobileNumber: string,
    linkedin: string,
    cooperation_type: number,
    lastEducationDegree: number,
    educationField: string,
    charities: any[],
    defaultCharityId: number | null,
    positionsTitle: string,
    hasApprovalRequired: boolean,
    hasApprovalForRegistering: boolean,
    avatar: string,
    gender: number | null = null,
  ) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.fullName = fullName;
    this.email = email;
    this.mobileNumber = mobileNumber;
    this.gender = gender;
    this.linkedin = linkedin;
    this.educationField = educationField;
    this.cooperation_type = cooperation_type;
    this.lastEducationDegree = lastEducationDegree;
    this.charities = charities || [];
    this.defaultCharityId = defaultCharityId;
    this.positionsTitle = positionsTitle;
    this.hasApprovalRequired = hasApprovalRequired;
    this.hasApprovalForRegistering = hasApprovalForRegistering;
    this.avatar_id = avatar;
  }
}
